/**
 * Base URL API backend. Set di .env: REACT_APP_API_URL=http://localhost:5000
 */
export const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export function apiUrl(path) {
  const base = API_BASE.replace(/\/$/, '');
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${base}${p}`;
}
